import React, { createElement } from 'react';
import moduleCss from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import Chip from 'Chip';

export interface NewsList_2_Props {
    nodeId?: string;
    style?: object;
    newsChip: TYPE_Chip
    useMaxHeight: boolean;
    maxHeight: number;

    isHasDot?: boolean
    dotStyle?: object

    titleHoverColor?: string
    titleStyle?: object

    isHasTime?: boolean
    timeStyle?: object
}

const NewsList_2: React.FC<NewsList_2_Props> = (props) => {
    const { nodeId, newsChip, style, useMaxHeight, maxHeight, isHasDot, dotStyle, titleHoverColor, titleStyle, isHasTime, timeStyle } = props;

    const newsChipData = useChip(newsChip as TYPE_Chip);
    const chipComponentData = formatChip(newsChip as TYPE_Chip);

    return (
        <Chip {...chipComponentData}>
            <div id={nodeId} className={moduleCss.newsList} style={style}>
                <ul
                    className={moduleCss.news}
                    style={{
                        ...(useMaxHeight && maxHeight ? { overflow: 'auto', maxHeight } : {}),
                    }}
                >
                    {newsChipData.map((item, index) => {
                        return (
                            <li key={index} style={{ ...titleStyle }}>
                                {
                                    isHasDot && <div style={dotStyle} />
                                }
                                <a
                                    className={moduleCss.title}
                                    href={item.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ '--hover-color': titleHoverColor }}
                                >
                                    {item.title}
                                </a>
                                {
                                    isHasTime &&
                                    <span className={moduleCss.time} style={timeStyle}>[{item.newsTime}]</span>
                                }
                            </li>
                        );
                    })}
                </ul>

                <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
            </div>
        </Chip>
    );
};

export default NewsList_2;
